import React, { useEffect } from 'react';
import { Container, Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, { PaginationProvider } from 'react-bootstrap-table2-paginator';
import {
  FaCaretSquareDown, FaCaretSquareUp, FaCaretUp, FaCaretDown,
} from 'react-icons/fa';
import ErrorMessage from '../../../../components/ErrorMessage';
import InviteUsers from '../InviteUsers';
import EmptyTableMessage from '../../../../components/EmptyTableMessage';
import Pagination from '../../../../components/Pagination/index';
import fetchUserDetails from '../../duck/actions/users';
import { SET_PAGINATION_PAGE_USERS } from '../../duck/types';

import style from './UsersTable.module.scss';

const UsersTable = () => {
  const { users, totalSize, page, sizePerPage, error, loading } = useSelector(state => state.usersReducer);
  const { bundle } = useSelector(state => state.loginReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    fetchUserDetails(bundle)(dispatch);
  }, [dispatch, bundle]);

  const sortIcon = (order) => {
    if (order === 'asc') return <FaCaretSquareDown className={style.orderIcon} />;
    if (order === 'desc') return <FaCaretSquareUp className={style.orderIcon} />;

    return (
      <div className={style.iconSort}>
        <FaCaretUp className={style.unsortIcon__up} />
        <FaCaretDown className={style.unsortIcon__down} />
      </div>
    );
  };

  const columns = [{
    dataField: 'fullName',
    text: 'USER',
    sort: true,
    sortCaret: sortIcon,
    headerStyle: {
      cursor: 'pointer',
    },
  }, {
    dataField: 'emailAddress',
    text: 'EMAIL ADDRESS',
    sort: true,
    sortCaret: sortIcon,
    headerStyle: {
      cursor: 'pointer',
    },
  }];

  if (error) return <ErrorMessage />;

  return (
    <div className={style.usersTableContainer}>
      <Container className={style.usersTable}>
        <PaginationProvider
          pagination={paginationFactory({
            custom: true,
            totalSize,
            page,
            sizePerPage,
          })}
        >
          {
            ({
              paginationProps,
              paginationTableProps,
            }) => (
                <div>
                  <BootstrapTable
                    keyField="id"
                    classes={style.table}
                    data={users}
                    columns={columns}
                    bordered={false}
                    headerClasses={style.header}
                    rowClasses={style.row}
                    noDataIndication={() => (
                      <EmptyTableMessage
                        loading={loading}
                        message="No users"
                      >
                        <InviteUsers />
                      </EmptyTableMessage>
                    )}
                    defaultSorted={[{
                      dataField: 'name',
                      order: 'desc',
                    }]}
                    {...paginationTableProps}
                  />
                  <Row align="center">
                    <Col sm="12" md={{ size: 6, offset: 3 }}>
                      <Pagination
                        paginationProps={paginationProps}
                        dispatchType={SET_PAGINATION_PAGE_USERS}
                      />
                    </Col>
                  </Row>
                </div>
              )
          }
        </PaginationProvider>
      </Container>
    </div>
  );
}

export default UsersTable;

UsersTable.propTypes = {
  loading: PropTypes.bool,
  fetchUserDetails: PropTypes.func,
  sizePerPage: PropTypes.number,
  totalSize: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  page: PropTypes.number,
  users: PropTypes.arrayOf(PropTypes.object),
  error: PropTypes.string,
  bundle: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
};

UsersTable.defaultProps = {
  error: undefined,
};
